import { Box, Typography } from "@mui/material";
import MainLayout from "../components/MainLayout.js";

export default function Relatorios() {
  return (
    <MainLayout>
      <Box>
        <Typography>Hello Word!</Typography>
        <Typography>Relatórios</Typography>
      </Box>
    </MainLayout>
  );
}
